import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { createContext, ReactNode, useContext } from "react";
import { ILanguage } from "../types/language";
import { API_URL } from "../utils/constants";
import { toast } from "sonner";

interface ILanguageApiResponse {
  result: ILanguage[];
}

interface ILanguageContext {
  languages_taught: ILanguage[];
}

const INITIAL_STATE = {
  languages_taught: [],
};

export const LanguageContext = createContext<ILanguageContext>(INITIAL_STATE);

export function LanguageContextProvider({ children }: { children: ReactNode }) {
  const fetchLanguages = async () => {
    try {
      const { data } = await axios<ILanguageApiResponse>(
        `https://core.pluritongues.com/languages/supported-languages`
      );
      return data.result as ILanguage[];
    } catch (error) {
      toast.error("Apologies, can't fetch languages at the moment.");
    }
  };

  const { data: languages_taught } = useQuery({
    queryKey: ["languages-taught"],
    queryFn: fetchLanguages,
  });

  return (
    <LanguageContext.Provider
      value={{ languages_taught: languages_taught ?? [] }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export default function useLanguages() {
  return useContext(LanguageContext);
}
